"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSecureEnvironment = void 0;
const web_ui_features_1 = require("@gruposantander/web-ui-features");
exports.isSecureEnvironment = window.ENVIRONMENT !== web_ui_features_1.DEV_ENVIRONMENT;
//# sourceMappingURL=session.utils.js.map